import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { translate } from 'react-i18next';
import BookingPhase from '../../components/BookingPhase/';
import TicketCard from '../../components/TicketCard';
import './byTicket.scss';

class ByTicket extends Component {

  componentWillMount() {
    const { ticketsLoaded, ticketsLoading, getTickets } = this.props;
    if (!ticketsLoaded && !ticketsLoading) {
      getTickets();
    }
  }

  render() {
    const { reservationByCode, tickets, selectTicket, selectedTicketCode,
      units, resources, groups, t } = this.props;

    const ticketsForBooking = tickets
      .filter(ticket => !ticket.reservation);
    const asMoment = date => moment(date, 'YYYY-MM-DD');
    ticketsForBooking.sort((a, b) => asMoment(a.openingDate).valueOf() - asMoment(b.openingDate).valueOf());
    const reservationByCodeDiv = reservationByCode ? (<div> { reservationByCode } <hr /> </div>) : null;
    return (
      <div className="reserve-by-ticket">
        <BookingPhase title={t('sectionTitles.selectATicket')} id={'byTicket'} />
        { reservationByCode &&
        reservationByCodeDiv
        }
        <div className="ticket-instructions">{t('ticket.instructions')}</div>
        {ticketsForBooking.length === 0 &&
          <div className="ticket-container-no-tickets" >{t('ticket.noTickets')}</div>
        }
        {ticketsForBooking.length > 0 &&
        <div className="ticket-container">
          {
            ticketsForBooking.map(ticket => (
              <div key={ticket.code || ticket.id}>
                <TicketCard
                  ticket={ticket}
                  onClick={selectTicket}
                  selectedTicketCode={selectedTicketCode}
                  unit={ticket.unit ? units[ticket.unit] : null}
                  allResources={resources}
                  allGroups={groups}
                  allUnits={units}
                  t={t}
                />
              </div>
              )
            )
          }
        </div>
        }
      </div>
    );
  }
}

ByTicket.propTypes = {
  tickets: PropTypes.array.isRequired,
  ticketsLoading: PropTypes.bool.isRequired,
  ticketsLoaded: PropTypes.bool.isRequired,
  getTickets: PropTypes.func.isRequired,
  selectTicket: PropTypes.func.isRequired,
  selectedTicketCode: PropTypes.string.isRequired,
  units: PropTypes.object.isRequired,
  resources: PropTypes.object.isRequired,
  groups: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  reservationByCode: PropTypes.element.isRequired
};

ByTicket.defaultProps = {
  tickets: [],
  ticketsLoaded: false,
  ticketsLoading: false,
  selectedTicketCode: '',
  units: {},
  reservationByCode: null
};

export default translate(['booking'], { wait: true })(ByTicket);



// WEBPACK FOOTER //
// ./src/containers/ByTicket/ByTicket.jsx